import { Component } from 'react';
import { withRouter } from 'react-router';

import events from '../../events';
import { refreshOAuthToken } from '../../utils/api';
import { RouterType } from '../../types/router';

class EventHandler extends Component {
  constructor(props) {
    super(props);

    this.messageParser = this.onMessageHandler.bind(this);
    this.loginHandler = this.login.bind(this);
    this.navigationHandler = this.navigate.bind(this);
  }

  componentWillMount() {
    document.addEventListener('message', this.messageParser, false);
    events.on('messages.login', this.loginHandler);
    events.on('messages.navigate', this.navigationHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('message', this.messageParser);
    events.off('messages.login', this.loginHandler);
    events.off('messages.navigate', this.navigationHandler);
  }

  onMessageHandler({ data: messageJSON }) {
    const message = JSON.parse(messageJSON);

    if (!message.type) {
      console.warn('[EventHandler] Invalid message format:', message);
      return null;
    }

    console.log(`[EventHandler] income message ${message.type}: `, message);
    events.emit(`messages.${message.type}`, message);
    return null;
  }

  login() {
    refreshOAuthToken();
  }

  navigate(postedMessage) {
    const {
      router: { history },
    } = this.props;

    const {
      message: {
        pathname,
        state = null,
      },
    } = postedMessage;

    history.push(pathname, state);
  }

  render() {
    return null;
  }
}

EventHandler.propTypes = {
  router: RouterType,
};

const EventHandlerWithRouter = withRouter(EventHandler);
export default EventHandlerWithRouter;



// WEBPACK FOOTER //
// ./src/app/components/EventHandler.js